import { ChangeColor } from './ChangeColor';

export class ChangeLinkOnLightColor extends ChangeColor {
  type: string = 'ChangeLinkOnLightColor';
}
